async function netRequestsOnline() {
  const regionsDefault = [
    {
      name: "Алтайский край",
      regionId: 69,
    },
    {
      name: "Амурская область",
      regionId: 31,
    },
    {
      name: "Архангельская область",
      regionId: 32,
    },
    {
      name: "Астраханская область",
      regionId: 33,
    },
    {
      name: "Белгородская область",
      regionId: 34,
    },
    {
      name: "Брянская область",
      regionId: 35,
    },
    {
      name: "Владимирская область",
      regionId: 36,
    },
    {
      name: "Волгоградская область",
      regionId: 37,
    },
    {
      name: "Вологодская область",
      regionId: 9,
    },
    {
      name: "Воронежская область",
      regionId: 10,
    },
    {
      name: "город Байконур",
      regionId: 59,
    },
    {
      name: "город Москва",
      regionId: 77,
    },
    {
      name: "город Санкт-Петербург",
      regionId: 78,
    },
    {
      name: "город Севастополь",
      regionId: 58,
    },
    {
      name: "Донецкая Народная республика",
      regionId: 87,
    },
    {
      name: "Еврейская АО",
      regionId: 79,
    },
    {
      name: "Забайкальский край",
      regionId: 75,
    },
    {
      name: "Запорожская область",
      regionId: 90,
    },
    {
      name: "Ивановская область",
      regionId: 11,
    },
    {
      name: "Иркутская область",
      regionId: 23,
    },
    {
      name: "Кабардино-Балкарская Республика",
      regionId: 19,
    },
    {
      name: "Калининградская область",
      regionId: 12,
    },
    {
      name: "Калужская область",
      regionId: 38,
    },
    {
      name: "Камчатский край",
      regionId: 39,
    },
    {
      name: "Карачаево-Черкесская Республика",
      regionId: 21,
    },
    {
      name: "Кемеровская область — Кузбасс",
      regionId: 40,
    },
    {
      name: "Кировская область",
      regionId: 41,
    },
    {
      name: "Костромская область",
      regionId: 13,
    },
    {
      name: "Краснодарский край",
      regionId: 70,
    },
    {
      name: "Красноярский край",
      regionId: 71,
    },
    {
      name: "Курганская область",
      regionId: 14,
    },
    {
      name: "Курская область",
      regionId: 86,
    },
    {
      name: "Ленинградская область",
      regionId: 15,
    },
    {
      name: "Липецкая область",
      regionId: 16,
    },
    {
      name: "Луганская Народная республика",
      regionId: 88,
    },
    {
      name: "Магаданская область",
      regionId: 60,
    },
    {
      name: "Московская область",
      regionId: 61,
    },
    {
      name: "Мурманская область",
      regionId: 62,
    },
    {
      name: "Ненецкий АО",
      regionId: 53,
    },
    {
      name: "Нижегородская область",
      regionId: 24,
    },
    {
      name: "Новгородская область",
      regionId: 25,
    },
    {
      name: "Новосибирская область",
      regionId: 26,
    },
    {
      name: "Омская область",
      regionId: 73,
    },
    {
      name: "Оренбургская область",
      regionId: 63,
    },
    {
      name: "Орловская область",
      regionId: 64,
    },
    {
      name: "Пензенская область",
      regionId: 42,
    },
    {
      name: "Пермский край",
      regionId: 81,
    },
    {
      name: "Приморский край",
      regionId: 72,
    },
    {
      name: "Псковская область",
      regionId: 82,
    },
    {
      name: "Республика Адыгея",
      regionId: 80,
    },
    {
      name: "Республика Алтай",
      regionId: 3,
    },
    {
      name: "Республика Башкортостан",
      regionId: 1,
    },
    {
      name: "Республика Бурятия",
      regionId: 2,
    },
    {
      name: "Республика Дагестан",
      regionId: 17,
    },
    {
      name: "Республика Ингушетия",
      regionId: 18,
    },
    {
      name: "Республика Калмыкия",
      regionId: 20,
    },
    {
      name: "Республика Карелия",
      regionId: 22,
    },
    {
      name: "Республика Коми",
      regionId: 4,
    },
    {
      name: "Республика Крым",
      regionId: 57,
    },
    {
      name: "Республика Марий Эл",
      regionId: 5,
    },
    {
      name: "Республика Мордовия",
      regionId: 6,
    },
    {
      name: "Республика Саха (Якутия)",
      regionId: 7,
    },
    {
      name: "Республика Северная Осетия - Алания",
      regionId: 8,
    },
    {
      name: "Республика Татарстан",
      regionId: 27,
    },
    {
      name: "Республика Тыва",
      regionId: 65,
    },
    {
      name: "Республика Хакасия",
      regionId: 66,
    },
    {
      name: "Ростовская область",
      regionId: 83,
    },
    {
      name: "Рязанская область",
      regionId: 84,
    },
    {
      name: "Самарская область",
      regionId: 85,
    },
    {
      name: "Саратовская область",
      regionId: 43,
    },
    {
      name: "Сахалинская область",
      regionId: 44,
    },
    {
      name: "Свердловская область",
      regionId: 45,
    },
    {
      name: "Смоленская область",
      regionId: 46,
    },
    {
      name: "Ставропольский край",
      regionId: 29,
    },
    {
      name: "Тамбовская область",
      regionId: 47,
    },
    {
      name: "Тверская область",
      regionId: 48,
    },
    {
      name: "Томская область",
      regionId: 49,
    },
    {
      name: "Тульская область",
      regionId: 50,
    },
    {
      name: "Тюменская область",
      regionId: 51,
    },
    {
      name: "Удмуртская Республика",
      regionId: 28,
    },
    {
      name: "Ульяновская область",
      regionId: 52,
    },
    {
      name: "Хабаровский край",
      regionId: 30,
    },
    {
      name: "Ханты-Мансийский АО — Югра",
      regionId: 54,
    },
    {
      name: "Херсонская область",
      regionId: 89,
    },
    {
      name: "Челябинская область",
      regionId: 74,
    },
    {
      name: "Чеченская Республика",
      regionId: 67,
    },
    {
      name: "Чувашская Республика — Чувашия",
      regionId: 68,
    },
    {
      name: "Чукотский АО",
      regionId: 55,
    },
    {
      name: "Ямало-Ненецкий АО",
      regionId: 56,
    },
    {
      name: "Ярославская область",
      regionId: 76,
    },
  ];

  const TGU = {
    operator: "TGU",
    dropChance: 0.5,
    DPO: {
      fetch:
        "",
      json: "/files/TGUDPO.json",
    },
    PO: {
      fetch:
        "",
      json: "/files/TGUPO.json",
    },
  };

  async function operatorPrograms(Operator) {
    let arr = [];

    let dpo_fetch = await getJson(Operator.DPO.fetch),
      dpo_json = await getJson(Operator.DPO.json),
      po_fetch = await getJson(Operator.PO.fetch),
      po_json = await getJson(Operator.PO.json);

    addPropertyProgram(dpo_fetch, arr, Operator);
    addPropertyProgram(dpo_json, arr, Operator);
    addPropertyProgram(po_fetch, arr, Operator, "po");
    addPropertyProgram(po_json, arr, Operator, "po");

    return arr.filter(
      (item, idx, arr) =>
        arr.findIndex((el) => el.shortName === item.shortName) == idx
    );
  }

  /* Добавление свойств для программ */
  function addPropertyProgram(programs, array, Operator, status = "dpo") {
    if (programs) {
      programs.map((item) => {
        item.operator = Operator.operator;
        item.dropChance = Operator.dropChance;

        if (status == "po") {
          item.po = true;
        }
      });

      array.push(...programs);
    }
  }

  /* Запрос на получение json */
  async function getJson(patch) {
    if (!patch) return;

    let result;

    try {
      /* На данный момент не все браузеры поддерживают AbortController */
      if ("AbortController" in window) {
        const response = await fetchWithTimeout(patch, {
          timeout: 3000,
        });
        result = await response.json();
      } else {
        const response = await fetch(patch);
        result = await response.json();
      }

      result.map((item) => {
        if (!item.regions) {
          item.regions = regionsDefault;
        }
      });

      return result;
    } catch (error) {
      console.log(error.name === "AbortError");
    }
  }

  /* Функция прерывания запроса через определенный промежуток времени на основе AbortController  */
  async function fetchWithTimeout(resource, options = {}) {
    const { timeout = 6000 } = options;

    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    const response = await fetch(resource, {
      ...options,
      signal: controller.signal,
    });
    clearTimeout(id);

    return response;
  }

  /* Передача массива программ фед операторов */
  const TGU_PROGRAMS = await operatorPrograms(TGU);

  return [...TGU_PROGRAMS];
}

export default netRequestsOnline;
